// @flow
export class AdInfo {
  id: string;
  title: string;
  duration: number;
  adUrl: string;

  constructor(id: string, title: string, duration: number, adUrl: string) {
    this.id = id;
    this.title = title;
    this.duration = duration;
    this.adUrl = adUrl;
  }
}

export default class AdSlotInfo {
  adSlotInfo: Array<AdInfo>;
  adSlotMediaUrls: Array<string>;
  adSlotMediaDurations: Array<number>;
  adsNumber: number;

  constructor(xmlBody: string) {
    this.adSlotInfo = [];
    const adSlotAdsIds = this._getLlBreaksAdIds(xmlBody);
    const adSlotAdsTitles = this._getLlBreaksTitles(xmlBody);
    this.adSlotMediaUrls = this._getLlBreaksMediaFiles(xmlBody);
    this.adSlotMediaDurations = this._getLlBreaksDurations(xmlBody);
    this.adsNumber = this.adSlotMediaUrls.length;
    if (
      adSlotAdsIds.length === adSlotAdsTitles.length &&
      adSlotAdsIds.length === this.adSlotMediaUrls.length &&
      adSlotAdsIds.length === this.adSlotMediaDurations.length
    ) {
      for (let i = 0; i < this.adsNumber; i += 1) {
        this.adSlotInfo.push(
          new AdInfo(
            adSlotAdsIds[i],
            adSlotAdsTitles[i],
            this.adSlotMediaDurations[i],
            this.adSlotMediaUrls[i],
          ),
        );
      }
    } else {
      console.warn('[CAST][AdSlotInfo] Ad slots data arrays DO NOT match!');
      this.adSlotMediaUrls = [];
      this.adSlotMediaDurations = [];
      this.adsNumber = 0;
    }
  }

  // matchAll() returns an array of arrays for the /gm match with groups. like: [ ['FULL match1', 'Group1'], ['FULL match2', 'Group1'] ]
  // we need only groups, which are our sought strings. example output for the _getLlBreaksMediaFiles match with 2 media files in XML:
  //
  // > Array ["<MediaFile height="720" width="1280" type="application/x-mpegURL" id="3254576" bitrate="3534" delivery="streaming">
  // <![CDATA[ https://d1dz1d1r2ut8ib.cloudfront.net/cea0/bS8xLzM4MTk2Mi83NS8xND/UxNDY3LzU2MzJfOTQubXA0/sling-hls/ad.m3u8 ]]>
  // </MediaFile>", "https://d1dz1d1r2ut8ib.cloudfront.net/cea0/bS8xLzM4MTk2Mi83NS8xND/UxNDY3LzU2MzJfOTQubXA0/sling-hls/ad.m3u8"]
  //
  // > Array ["<MediaFile height="720" width="1280" type="application/x-mpegURL" id="3254538" bitrate="3574" delivery="streaming">
  // <![CDATA[ https://d1dz1d1r2ut8ib.cloudfront.net/c6f3/bS8xLzM4MTk2Mi83My8xND/UxNDY1LzU0MDlfOTQubXA0/sling-hls/ad.m3u8 ]]>
  // </MediaFile>", "https://d1dz1d1r2ut8ib.cloudfront.net/c6f3/bS8xLzM4MTk2Mi83My8xND/UxNDY1LzU0MDlfOTQubXA0/sling-hls/ad.m3u8"]
  _magicMatch = (xmlBody: string, regExp: RegExp) =>
    // $FlowFixMe
    [...xmlBody.matchAll(regExp)].map((array: Array<string>) =>
      array.length > 1 ? array[1] : undefined,
    );

  _getLlBreaksMediaFiles = (xmlBody: string) => {
    const regExp = /(?:<MediaFile[^>]*>\s*(?:<!\[CDATA\[)\s*)(\S+)(?:\s*(?:\]\]>)\s*<\/MediaFile>)/gm;
    const mediaFiles = this._magicMatch(xmlBody, regExp);
    return mediaFiles;
  };

  _getLlBreaksDurations = (xmlBody: string) => {
    const regExp = /(?:<Duration>\s*)(\S+)(?:\s*<\/Duration>)/gm;
    let durations = this._magicMatch(xmlBody, regExp);
    durations = durations.map(time => {
      const parts = time.match(/(\d\d):(\d\d):(\d\d)/);
      if (!parts) return -1;
      return +parts[1] * 3600 + +parts[2] * 60 + +parts[3];
    });
    return durations;
  };

  _getLlBreaksTitles = (xmlBody: string) => {
    const regExp = /(?:<AdTitle>\s*)([^<>]+)(?:\s*<\/AdTitle>)/gm;
    const titles = this._magicMatch(xmlBody, regExp);
    return titles;
  };

  _getLlBreaksAdIds = (xmlBody: string) => {
    const regExp = /(?:<Ad\s+id=")([^.]+)/gm;
    const adIds = this._magicMatch(xmlBody, regExp);
    return adIds;
  };
}
